function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "M14.874 14.965c-1.623-1.6-1.623-3.196-1.623-4.882V7.92a5.15 5.15 0 0 0-.976-3.009 5.25 5.25 0 0 0-2.56-1.892 1.56 1.56 0 0 0 .035-.29A1.74 1.74 0 0 0 8 1a1.74 1.74 0 0 0-1.75 1.73c.003.097.014.194.035.29a5.252 5.252 0 0 0-2.56 1.891 5.15 5.15 0 0 0-.976 3.009v2.163c0 1.686 0 3.282-1.623 4.882a.43.43 0 0 0-.092.472.439.439 0 0 0 .403.268H6.25c0 .955.784 1.73 1.75 1.73a1.74 1.74 0 0 0 1.75-1.73h4.813a.439.439 0 0 0 .403-.268.43.43 0 0 0-.092-.472zM7.124 2.73A.87.87 0 0 1 8 1.864a.87.87 0 0 1 .876.866v.074a5.035 5.035 0 0 0-1.716 0c-.035-.026-.035-.048-.035-.074zM8 16.57a.87.87 0 0 1-.875-.865h1.75a.86.86 0 0 1-.256.611.88.88 0 0 1-.619.254zm-5.6-1.73c1.225-1.61 1.225-3.205 1.225-4.757V7.92c0-1.545.834-2.973 2.187-3.746a4.42 4.42 0 0 1 4.376 0 4.317 4.317 0 0 1 2.187 3.746v2.163c0 1.553 0 3.149 1.225 4.757H2.4z"
});

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18"
  }, props), _ref);
}

export default SvgBell;